import { StencilCDNImage } from '@/components/Common/StencilImage'

export default function Logo() {
  return (
    <div className="w-32 md:w-40">
      <StencilCDNImage
        src="https://indcdn.indmoney.com/public/ind-marketing/indstockslogonew.png"
        alt="Download INDstocks app on app store"
        width={220}
        height={73}
        unoptimized
      />
    </div>
  )
}
